<template>
  <div class="box">
    <van-row class="top" type="flex">
      <van-col>
        <van-image class="top-avatar" round :src="user.avatar" />
      </van-col>
      <van-col>
        <p class="top-name">{{user.name}} {{year + '年' + month + '月'}}工资</p>
        <p class="top-dept">工资编号：{{wages.userID}}</p>
        <p class="top-dept">{{user.deptName}}</p>
        <p class="top-dept">应发合计：￥{{wages.yfhj}}</p>
        <p class="top-dept">实发合计：￥{{wages.sfhj}}</p>
      </van-col>
    </van-row>
    <van-row class="wages-box">
      <van-tabs v-model="active" scrollspy sticky offset-top="144px">
        <van-tab v-for="(item, index) in group" :key="index" :title="item.title">
          <div class="info-box">
            <van-cell-group :title="item.title">
              <div v-for="prop in item.info" :key="prop.prop">
                <van-cell v-if="(wages[prop.prop] && wages[prop.prop] != '0') || prop.prop == 'ks'" :title="prop.title" :value="(prop.prop == 'dy' || prop.prop == 'lxmx') ?  wages[prop.prop] : '￥'+ wages[prop.prop]" />
              </div>
            </van-cell-group>
          </div>
        </van-tab>
      </van-tabs>
    </van-row>
  </div>
</template>

<script>
  export default {
    name: "wagesInfo",
    title: "工资详情",
    data () {
      return {
        user: { avatar: "", name: "", deptName: "" },
        active: 0,
        group: [
          {
            title: "基本工资", info: [
              { title: "基本工资", prop: "jbgz" },
              { title: "岗位工资", prop: "gwgz" },
              { title: "薪级工资", prop: "xjgz" },
              { title: "工龄工资", prop: "glgz" },
              { title: "岗位津贴", prop: "gwjt" },
              { title: "业务津贴", prop: "ywjt" },
              { title: "基础性绩效1", prop: "jxgz" },
              { title: "基础性绩效2", prop: "jxgZ2" },
              { title: "预发课酬", prop: "yfkc" },
              { title: "月绩效", prop: "yjx" },
              { title: "交通补贴", prop: "jtbt" },
              { title: "伙食补贴", prop: "hsbt" },
              { title: "通讯补贴", prop: "txbt" },
              { title: "过渡性补贴", prop: "gdxbt" },
              { title: "其他补贴", prop: "qtbt" },
              { title: "标准合计", prop: "bzbt" }
            ]
          },
          {
            title: "补发工资", info: [
              { title: "补发岗位工资", prop: "bfgwgz" },
              { title: "补发薪级工资", prop: "bfxjgz" },
              { title: "补发工龄工资", prop: "bfglgz" },
              { title: "补发岗位津贴", prop: "bfgwjt" },
              { title: "补发业务津贴", prop: "bfywjt" },
              { title: "补发上期绩效工资", prop: "bfsqjxgz" },
              { title: "补发基础性绩效1", prop: "bfjxgz" },
              { title: "补发基础性绩效2", prop: "bfjxgZ2" },
              { title: "补发月绩效", prop: "bfyjx" },
              { title: "补发交通补贴", prop: "bfjtbt" },
              { title: "补发伙食补贴", prop: "bfhsbt" },
              { title: "补发通讯补贴", prop: "bftxbt" },
              { title: "补发过渡性补贴", prop: "bfgdxbt" },
              { title: "补发其他", prop: "bfqt" },
              { title: "补发合计", prop: "bfgj" }
            ]
          },
          {
            title: "其他项目", info: [
              { title: "年终", prop: "nz" },
              { title: "年终明细", prop: "nzmx" },
              { title: "零星", prop: "lx" },
              { title: "应发合计", prop: "yfhj" },
              { title: "零星明细", prop: "lxmx" }
            ]
          },
          {
            title: "已发项目", info: [
              { title: "已发金额", prop: "yfje" },
            ]
          },
          {
            title: "扣款项目", info: [
              { title: "税前工资", prop: "sqgz" },
              { title: "扣税", prop: "ks" },
              { title: "扣养老保险", prop: "kylbx" },
              { title: "扣医疗保险", prop: "kylbX2" },
              { title: "扣失业保险", prop: "ksybx" },
              { title: "扣保险合计", prop: "kbxhj" },
              { title: "扣保险其他", prop: "kbxqt" },
              { title: "扣公积金", prop: "kgjj" },
              { title: "补扣公积金", prop: "bkgjj" },
              { title: "扣工会会费", prop: "kghhf" },
              { title: "补扣工会会费", prop: "bkghhf" },
              { title: "其他代扣", prop: "qtdk" },
              { title: "扣岗位工资", prop: "kgwgz" },
              { title: "扣薪级工资", prop: "kxjgz" },
              { title: "扣工龄工资", prop: "kglgz" },
              { title: "扣岗位津贴", prop: "kgwjt" },
              { title: "扣业务津贴", prop: "kywjt" },
              { title: "扣上期绩效工资", prop: "ksqjxgz" },
              { title: "扣基础性绩效1", prop: "kjxgz" },
              { title: "扣基础性绩效2", prop: "kjxgZ2" },
              { title: "扣月绩效", prop: "kyjx" },
              { title: "扣交通补贴", prop: "kjtbt" },
              { title: "扣伙食补贴", prop: "khsbt" },
              { title: "扣通讯补贴", prop: "ktxbt" },
              { title: "扣过渡性补贴", prop: "kgdxbt" },
              { title: "其他扣款", prop: "qtkk" },
              { title: "扣工资合计", prop: "kgzhj" },
              { title: "扣款合计", prop: "kkhj" },
            ]
          },
          {
            title: "实发合计", info: [
              { title: "实发合计", prop: "sfhj" }
            ]
          },
          {
            title: "参考数据", info: [
              { title: "d基数", prop: "dJS" },
              { title: "df参考", prop: "dfCK" },
              { title: "子女教育累计", prop: "znjylj" },
              { title: "继续教育累计", prop: "jxjylj" },
              { title: "住房贷款累计", prop: "zfdklj" },
              { title: "住房租金累计", prop: "zfzjlj" },
              { title: "赡养老人累计", prop: "sylrlj" },
              { title: "累计收入", prop: "ljsr" },
              { title: "累计税", prop: "ljs" },
              { title: "免征额累计", prop: "mzelj" },
            ]
          },
        ],
        wages: {}
      }
    },
    props: {
      year: { type: String, required: true },
      month: { type: String, required: true }
    },
    created () {
      this.Ajax.Get("api/User/GetMyInfo").then(res => {
        this.user = res.data;
      })
      this.Ajax.Get("api/Wages/GetMyInfo/" + this.year + "/" + this.month).then(res => {
        this.wages = res.data;
      })
    },
    methods: {

    },
  }
</script>
<style scoped>
  .top {
    color: #fff;
    background-color: #1989fa;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 999;
  }
  .top-name {
    margin-top: 10px;
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
  }
  .top-dept {
    font-size: 12px;
    line-height: 26px;
    color: #fff;
  }
  .top-avatar {
    margin: 10px 20px;
    width: 50px;
    padding: 2px;
    background-color: #fff;
  }
  .wages-box {
    padding-top: 144px;
  }
</style>